import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FEATURES } from 'app/@common/constants'

export default function SelectFeatures({...props}) {

    const myProps = {
        urlAjax: FEATURES.LIST_URL,
        placeholder: 'Features', icon: {icon: 'user-tag'},
        isMulti: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}